<button id="translatebtn" (click)="send()">Translate</button>

<textarea  [(ngModel)]="value" name="value"></textarea>